import React, { useState } from 'react';
import axios from 'axios';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { postData } from '@/services/api.service';
import { useSelector } from 'react-redux';
import { RootState } from '@/core/redux/store';

// Define validation schema using Yup
const schema = yup.object().shape({
  order_id: yup.string().required('Order ID is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
});

interface FormValues {
  order_id: string;
  email: string;
}

const TrackOrder: React.FC = () => {
  const [sale, setSale] = useState<any>(null);
  const [productSales, setProductSales] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const currencyCode = useSelector(
    (state: RootState) => state.common.header?.currency?.symbol
  );

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: FormValues) => {
    setLoading(true);
    setError(null);

    const payload = {
      id: data?.order_id,
    };

    try {
      const response = await postData('track_order', payload);
      if (response?.status == 200 || response?.status == 201) {
        console.log('response', response);
        setSale(response.data.data.sale);
        setProductSales(response.data.data.products || []);
        setValue('email', '');
        setValue('order_id', '');
      }
    } catch (err) {
      setError('Order not found. Please check your Order ID and Email.');
      setSale(null);
      setProductSales([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="user-login-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            {sale ? (
              <>
                <div className="order-details card mb-3">
                  <div className="card-header">
                    <h3 className="text-center mb-0">
                      Order ID- {sale.reference_no}
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <span className="text-muted">Time : </span>
                          <span>
                            {new Date(sale.created_at).toLocaleString()}
                          </span>
                        </div>
                        <div className="mb-3">
                          <span className="text-muted">Order Status : </span>
                          <span>{sale.order_status}</span>
                        </div>
                        <div className="mb-3">
                          <span className="text-muted">Payment Method : </span>
                          <span>{sale.payment_mode}</span>
                        </div>
                        <div className="mb-3">
                          <span className="text-muted">Payment Status : </span>
                          <span>{sale.payment_status}</span>
                        </div>
                        <div className="mb-3">
                          <span className="text-muted">Shipping Status : </span>
                          <span>{sale.shipping_status}</span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <span className="text-muted">Name : </span>
                          <span>{sale.billing_name}</span>
                        </div>
                        <div className="mb-3">
                          <span className="text-muted">Phone : </span>
                          <span>{sale.billing_phone}</span>
                        </div>
                        <div className="mb-3">
                          <span className="text-muted">Address : </span>
                          <span>{sale.billing_address}</span>
                          <span>, {sale.billing_city}</span>
                          <span>, {sale.billing_country}</span>
                        </div>
                      </div>
                    </div>
                    <hr className="mt-3 mb-3" />
                    <div className="cart-table table-content table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th style={{ textAlign: 'left' }}>Product</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productSales?.map((product) => (
                            <tr className="sale-41">
                              <td
                                className="d-flex"
                                style={{ textAlign: 'left' }}
                              >
                                <img
                                  loading="lazy"
                                  className="product-img"
                                  style={{ width: '100px', height: '100px' }}
                                  alt={product?.product?.name}
                                  src={product?.product?.image_path}
                                />
                                <div>
                                  {product?.product?.name}
                                  <br />
                                  <span className="text-muted">
                                    {product.product_variant != null &&
                                      `(${product.product_variant.variant.name})`}
                                  </span>
                                </div>
                              </td>
                              <td> {product?.qty}</td>
                              <td> {product?.total}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tbody>
                          <tr>
                            <td></td>
                            <td>
                              <span className="text-muted">Shipping</span>
                            </td>
                            <th>
                              (+) {currencyCode}
                              &nbsp;{sale?.shipping_cost}
                            </th>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <span className="text-muted">Discount</span>
                            </td>
                            <th>
                              (-) {currencyCode}
                              &nbsp;{sale?.total_discount}
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            <th>
                              <h4>Total</h4>
                            </th>
                            <th>
                              <h4>
                                {currencyCode}
                                &nbsp;{sale?.grand_total}
                              </h4>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => setSale(null)}
                  className="button lg style1 d-block text-center mt-5"
                >
                  Track another order
                </button>
              </>
            ) : (
              // <div className="order-details card mb-5">
              //   <div className="card-header">
              //     <h3 className="text-center mb-0">
              //       Order ID - {sale.reference_no}
              //     </h3>
              //   </div>
              //   <div className="card-body">
              //     <p>Time: {new Date(sale.created_at).toLocaleString()}</p>
              //     <p>
              //       Order Status:{' '}
              //       {sale.sale_status === 1 ? 'Complete' : 'Pending'}
              //     </p>
              //     <p>Payment Method: {sale.payment_mode}</p>
              //     <p>
              //       Payment Status:{' '}
              //       {sale.payment_status === 4 ? 'Paid' : 'Pending'}
              //     </p>
              //     <h4>Order Items:</h4>
              //     <ul>
              //       {productSales.map((product, index) => (
              //         <li key={index}>
              //           <img
              //             src={`/images/product/small/${product.image || 'placeholder.jpg'}`}
              //             alt={product.name}
              //             style={{ width: '50px', marginRight: '10px' }}
              //           />
              //           {product.name} - {product.qty} x USD
              //           {product.net_unit_price}
              //         </li>
              //       ))}
              //     </ul>
              //     <h4>
              //       Total: USD
              //       {sale.grand_total - sale.coupon_discount}
              //     </h4>
              //   </div>
              // </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="card-box mb-0">
                  <div className="form-group">
                    <label>Order ID</label>
                    <Controller
                      name="order_id"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="form-control"
                          placeholder="Order ID"
                        />
                      )}
                    />
                    {errors.order_id && (
                      <small className="text-danger">
                        {errors.order_id.message}
                      </small>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Email Address</label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="email"
                          className="form-control"
                          placeholder="Email"
                        />
                      )}
                    />
                    {errors.email && (
                      <small className="text-danger">
                        {errors.email.message}
                      </small>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="button style1 d-block"
                    disabled={loading}
                  >
                    {loading ? 'Tracking...' : 'Track Order'}
                  </button>
                  {error && <p className="text-danger mt-2">{error}</p>}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrackOrder;
